import { useMemo } from "react";
import { IEmployee, IMap } from "../../globals/interfaces";

export default function useExistingEmployees (employees: Array<IEmployee>) {

    const { employeeNumbers, employeeEmails } = useMemo(() => {
        const employeeNumbers = new Set();
        const employeeEmails = new Set();
        for (const { s_email, i_employee_number } of employees) {
            employeeNumbers.add(i_employee_number);
            employeeEmails.add(s_email.toUpperCase())
        }
        return {
            employeeNumbers,
            employeeEmails
        };
    }, [employees]);

    const existingEmployeeData = {
        employeeNumbers,
        employeeEmails
    }

    return existingEmployeeData;
}